var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralIconsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.999,
    height: 13.999,
    viewBox: "0 0 13.999 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.386-8.364a1.31,1.31,0,0,0,0-1.857l-1.643-1.643a1.315,1.315,0,0,0-1.857,0L-5.146-10.6a.328.328,0,0,0,0,.465L-2.111-7.1a.328.328,0,0,0,.465,0ZM-6.229-9.521l-7.18,7.18-.58,3.322a.657.657,0,0,0,.76.76l3.322-.582,7.18-7.18a.328.328,0,0,0,0-.465L-5.761-9.521A.332.332,0,0,0-6.229-9.521ZM-11.594-.656h1.313V.336l-1.764.309-.85-.85.309-1.764h.993Z",
    transform: "translate(13.999 12.248)",
    fill: "#888075",
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsEdit);
export default __webpack_public_path__ + "static/media/generalIcons_Edit.4f97dd85.svg";
export { ForwardRef as ReactComponent };